<!-- Zweck: Stellt die Auswahl für den AWEG-Import-Hinweis bereit. -->
<h1 mat-dialog-title>Verbringung aus dem EWR</h1>

<div mat-dialog-content class="import-hinweis-content">
  <p>
    Für den ausgewählten DE-Artikel sollen mehr als 3 Packungen in den Warenkorb gelegt werden.
    Bitte treffen Sie eine Entscheidung gemäß § 11 Abs. 1 Z 7 AWEG.
  </p>

  <label class="import-hinweis-option">
    <input type="radio" name="importHinweisOption" value="exception" [(ngModel)]="selectedOption">
    <span>
      Die Verbringung von mehr als 3 Packungen des Arzneimittels fällt unter die Ausnahmebestimmung
      des § 11 Abs. 1 Z 7 AWEG, da ich für mehr als einen Patienten im Rahmen der Ausnahmebestimmung
      (drei Packungen pro Patient, „Kleinmengenregelung“) bestelle; dazu kann ich der Behörde den
      Nachweis liefern.
    </span>
  </label>

  <label class="import-hinweis-option">
    <input type="radio" name="importHinweisOption" value="selfReport" [(ngModel)]="selectedOption">
    <span>Ich werde die Meldung gemäß AWEG selbst durchführen.</span>
  </label>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="reduce()">
    Menge auf 3 Stück reduzieren
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selectedOption" (click)="confirm()">
    Auswahl bestätigen
  </button>
</div>
